<ng-container>
  <!-- CM Mode -->
  <div class="w-full custom-height-input" *ngIf="conversionLengthService.preferredLengthUnit === HeightUnit.CM">
    <div class="flex flex-col ">
      <div class="flex">
        <mat-form-field
          class="w-full"
          appearance="outline"

        >
          <mat-label>{{this.label}}</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="cm"
            (ngModelChange)="onInputChange()"
            (blur)="onBlur()"
            (focus)="onFocus()"

          />
          <span matSuffix class="text-gray-500 text-sm px-1">cm</span>
        </mat-form-field>
      </div>
      <mat-error
        *ngIf="
          ngControl?.control?.hasError('required') &&
          ngControl?.control?.touched
        "
      >
        {{this.label}} is required
      </mat-error>
      <mat-error
        *ngIf="
          (ngControl?.control?.hasError('min') || ngControl?.control?.hasError('max')) && ngControl?.control?.touched
        "
      >
        select a value between {{limits.CM.MIN}}cm and {{limits.CM.MAX}}cm
      </mat-error>
    </div>
  </div>

  <!-- IN Mode -->
  <div
    class="w-full custom-height-input"
    *ngIf="conversionLengthService.preferredLengthUnit === HeightUnit.IN"
  >
    <div
      class="flex flex-col"
      [ngClass]="{ 'custom-field-focused': isFocused, 'custom-field-hovered': isHovered }"
        (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
    >
      <!-- Single inches input (e.g. neck size) -->
      <div class="flex" *ngIf="inchesOnly">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{this.label}}</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="totalInches"
            (ngModelChange)="onInputChange()"
            (focus)="onFocus()"
            (blur)="onBlur()"
          />
          <span matSuffix class="text-gray-500 text-sm px-0.5">in</span>
        </mat-form-field>
      </div>

      <!-- Feet + inches input (e.g. height) -->
      <div class="flex" *ngIf="!inchesOnly">
        <mat-form-field appearance="outline" class="flex-1 no-right-border">
          <mat-label>{{this.label}}</mat-label>
          <input
            matInput
            type="number"
            [(ngModel)]="feet"
            (ngModelChange)="onInputChange()"
            (focus)="onFocus()"
            (blur)="onBlur()"

          />
          <span matSuffix class="text-gray-500 text-sm px-0.5">ft</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1 no-left-border">
          <input
            matInput
            type="number"
            [(ngModel)]="inches"
            (ngModelChange)="onInputChange()"
            (focus)="onFocus()"
            (blur)="onBlur()"
          />
          <span matSuffix class="text-gray-500 text-sm px-0.5">in</span>
        </mat-form-field>
      </div>
      <mat-error
        *ngIf="
          ngControl?.control?.hasError('required') &&
          ngControl?.control?.touched
        "
      >
        {{this.label}} is required
      </mat-error>
      <mat-error
        *ngIf="
         inchesOnly && ( ngControl?.control?.hasError('min') || ngControl?.control?.hasError('max')) && ngControl?.control?.touched
        "
      >
        select a value between {{limits.IN.MIN}}in and {{limits.IN.MAX}}in
      </mat-error>
      <mat-error
        *ngIf="
         !inchesOnly && ( ngControl?.control?.hasError('min') || ngControl?.control?.hasError('max')) && ngControl?.control?.touched
        "
      >
        select a value between {{limits.IN.MIN.feet}}.{{limits.IN.MIN.inches}}ft and {{limits.IN.MAX.feet}}.{{limits.IN.MAX.inches}}ft
      </mat-error>
    </div>
  </div>
</ng-container>
